import { useCallback } from "react";
import { upsertChat } from "instantdb/client/chat";
import { generateChatTitle } from "@/utilities/chat-helpers";

export const useChatTitle = () => {
  const updateChatTitle = useCallback(async (chatId: string, userId: string, content: string) => {
    try {
      const aiTitle = await generateChatTitle(content);

      await upsertChat({
        id: chatId,
        userId,
        title: aiTitle,
        updatedAt: new Date().toISOString(),
      });
    } catch (error) {
      console.warn("Failed to generate AI title:", error);

      // Clear loading state even if title generation fails
      try {
        await upsertChat({
          id: chatId,
          userId,
          updatedAt: new Date().toISOString(),
        });
      } catch (clearError) {
        console.warn("Failed to clear loading state:", clearError);
      }
    }
  }, []);

  return { updateChatTitle };
};

